import { HEROKU_AUTHORIZATION } from "../utils/URLconsts"

class ApiService {
  constructor(baseURL) {
    this.baseURL = baseURL;
    this.globalUID =  global?.user?.UID || global?.user?.uID;
  }

  setBaseUrl(url){
    this.baseURL = `${url}`
  }

  setUserToken(token){
    this.token = token
  }

  async request(endpoint, method = 'GET', data = null, headers = {}) {
    const url = `${this.baseURL}${endpoint}`;

    const config = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': HEROKU_AUTHORIZATION,
        'x-request-user':  this.globalUID || null,
        ...headers
      }
    };

    if (data) {
      config.body = JSON.stringify(data);
    }

    try {
      const response = await fetch(url, config);

      return response;
    } catch (error) {
      console.log('endpoint -->', endpoint, error)
      throw error;
    }
  }

  get(endpoint, headers = {}) {
    return this.request(endpoint, 'GET', null, headers);
  }

  post(endpoint, data, headers = {}) {
    return this.request(endpoint, 'POST', data, headers);
  }

  put(endpoint, data, headers = {}) {
    return this.request(endpoint, 'PUT', data, headers);
  }

  delete(endpoint, headers = {}) {
    return this.request(endpoint, 'DELETE', null, headers);
  }
}

export default ApiService;